/* eslint-disable */
// @ts-nocheck
import React, { PureComponent } from 'react';
import * as R from 'ramda';
import { ACCESS_CONTROL_PROPS } from '../../support/accessControlConstants';
import { Dropdown } from '../../components/core';
import AccessControlWrapper from './AccessControlWrapper';
import { ACCESS_COMPONENT_DEFAULT_PROPS } from './ts/AccessControl.constants';
type Props = {
  accessResources: Array<string>;
  permission: number;
};
export default class AccessDropdown extends PureComponent<Props> {
  static defaultProps = ACCESS_COMPONENT_DEFAULT_PROPS;

  render() {
    const { accessResources, permission } = this.props;
    return (
      <AccessControlWrapper accessResources={accessResources} permission={permission}>
        <Dropdown {...R.omit(ACCESS_CONTROL_PROPS, this.props)} />
      </AccessControlWrapper>
    );
  }
}
